import newsListStore from '@modules/news/news-list-store';
import newsViewStore from '@modules/news/news-view-store';
import newsImporterStore from '@modules/news/news-importer-store';
import newsFormStore from '@modules/news/news-form-store';
import newsDestroyStore from '@modules/news/news-destroy-store';

export default {
  namespaced: true,

  modules: {
    destroy: newsDestroyStore,
    form: newsFormStore,
    list: newsListStore,
    view: newsViewStore,
    importer: newsImporterStore,
  },
};
